import React, { useState } from 'react';
const faqs = [{
  question: 'What is the AI Storefront?',
  answer: 'The AI Storefront is every layer of your store, powered by AI. The store builder, the shopping assistant, personalized pages, dynamic collections, agent infrastructure, merchant tools. It\'s not a plugin or a feature added on top of what you have. It\'s how the whole store works.'
}, {
  question: 'Do I need to rebuild my store to use this?',
  answer: 'Not unless you want to. Chat Mode adds the AI Shopping Assistant on top of your existing store — no rebuild, no migration. Full Mode is a complete rebuild using our native storefront builder, giving you the whole AI Storefront experience.'
}, {
  question: 'Is this just a chatbot?',
  answer: 'The AI Shopping Assistant is one of many features. The AI Storefront also rebuilds pages per shopper, builds dynamic collections in real time, makes your store readable by AI agents, remembers shoppers across sessions, supports 70+ languages, and more. A chatbot is a layer on top of a static store. This is the whole store.'
}, {
  question: 'How does the AI know my brand?',
  answer: 'It inherits it. Your brand guidelines — colors, typography, tone, interactions — are built in from the start. The AI works from your catalog and your voice. It doesn\'t improvise outside what you\'ve defined. If it doesn\'t know something, it says so.'
}, {
  question: 'What are AI agents and why should I care?',
  answer: 'AI agents are software that shop on behalf of real people — researching, comparing, and buying across stores. They\'re already being used. When an agent comes to your store, it needs structured data, real-time inventory, and semantic search. If your store isn\'t built for them, it doesn\'t show up. The AI Storefront is.'
}, {
  question: 'How long does setup take?',
  answer: 'Chat Mode is fast — days, not months. Full Mode takes longer because it\'s a complete rebuild, but we handle the catalog transformation and technical setup. Most stores go live within a few weeks.'
}];
export const AIStorefrontFAQ = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const [isMobile, setIsMobile] = React.useState(() => window.innerWidth < 768);
  React.useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  const toggle = (i: number) => {
    setOpenIndex(prev => prev === i ? -1 : i);
  };
  return <section data-name="FAQ" data-nav-theme="dark" style={{
    backgroundColor: '#091717',
    width: '100%'
  }}>
      <div className="section-content faq-container" style={{
      maxWidth: '1360px',
      margin: '0 auto',
      width: '100%',
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '100px',
      paddingBottom: '100px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '48px'
    }}>
        {/* Left column — title */}
        <div data-name="FAQ Title" className="faq-title-col" style={{
        width: '35%',
        flexShrink: 0
      }}>
          <h2 className="section-title" style={{
          fontSize: 'clamp(52px, 7vw, 92px)',
          lineHeight: 1.05,
          color: '#FCFAF6',
          fontFamily: 'Instrument Sans, sans-serif',
          fontWeight: 400,
          margin: 0
        }}>
            FAQs
          </h2>
        </div>

        {/* Right column — accordion */}
        <div data-name="FAQ Accordion" className="faq-accordion" style={{
        flex: 1,
        minHeight: '420px'
      }}>
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} data-name={`FAQ Item ${i + 1}`} style={{
            borderTop: 'none',
            borderBottom: 'none'
          }}>
                {/* Question row */}
                <button onClick={() => toggle(i)} aria-expanded={isOpen} aria-controls={`aisf-faq-panel-${i}`} style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 0',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              gap: '24px'
            }} data-tracking-id="btn-aisf-faq-toggle">
                  <span className="faq-question" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 500,
                fontSize: '24px',
                color: '#FCFAF6',
                lineHeight: 1.3
              }}>
                    {faq.question}
                  </span>
                  <span style={{
                display: 'inline-block',
                fontSize: '14px',
                lineHeight: 1,
                color: '#FCFAF6',
                flexShrink: 0,
                minWidth: '14px',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease'
              }} aria-hidden="true">▾</span>
                </button>

                {/* Answer */}
                <div id={`aisf-faq-panel-${i}`} role="region" style={{
              maxHeight: isOpen ? '500px' : '0',
              overflow: 'hidden',
              opacity: isOpen ? 1 : 0,
              transition: 'max-height 0.4s ease, opacity 0.4s ease'
            }}>
                  <p className="faq-answer" style={{
                fontFamily: 'Instrument Sans, sans-serif',
                fontWeight: 400,
                fontSize: isMobile ? '16px' : '20px',
                color: '#FCFAF6',
                lineHeight: 1.6,
                margin: 0,
                paddingBottom: '28px'
              }}>
                    {faq.answer}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
};